export class Client {
    client_id: string;
    client_secret: string;
    client_name: string;
    app_name: string;
    app_description: string;
    allow_access: boolean;
}